import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getIdVerification,
  runIdVerification,
} from "../applications/applicants-service"
import { IdVerificationResult } from "../applications/dtos/IdVerificationDto"

export function useGetIdVerification(
  organizationId: string | undefined,
  candidateId: string | undefined,
  enabled: boolean,
) {
  return useQuery<IdVerificationResult | null>({
    queryKey: ["id-verification", candidateId],
    queryFn: () => getIdVerification(organizationId!, candidateId!),
    enabled: enabled && !!organizationId && !!candidateId,
    staleTime: 0,
  })
}

export function useRunIdVerification(
  organizationId: string | undefined,
  candidateId: string | undefined,
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      idNumber,
      forceRerun,
    }: {
      idNumber: string
      forceRerun?: boolean
    }) => runIdVerification(organizationId!, candidateId!, idNumber, forceRerun),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["id-verification", candidateId],
      })
    },
  })
}
